import React from 'react';

// Abacus: HA_PULSE_SKELETON_ABC
import {SkeletonLoading} from '../../abacus/skeleton-abc';

export default function LazyThreePack({image1, image2, image3, isLoading}) {
    return (
        <div className="three-pack">
            <div className="three-pack__grid">
                <div className="three-pack__column">
                    <SkeletonLoading loading={isLoading}>
                        <div
                            className="three-pack__image three-pack__image--rounded-top-and-bottom-left three-pack__image--left-panel"
                            style={(image1 ? {backgroundImage: `url(${image1})`} : {})}
                        />
                    </SkeletonLoading>
                </div>
                <div className="three-pack__separator" />
                <div className="three-pack__column">
                    <SkeletonLoading loading={isLoading}>
                        <div
                            className="three-pack__image three-pack__image--rounded-top-right"
                            style={(image2 ? {backgroundImage: `url(${image2})`} : {})}
                        />
                    </SkeletonLoading>
                        <div className="three-pack__separator" />
                    <SkeletonLoading loading={isLoading}>
                        <div
                            className="three-pack__image three-pack__image--rounded-bottom-right"
                            style={(image3 ? {backgroundImage: `url(${image3})`} : {})}
                        />
                    </SkeletonLoading>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/universal/abacus/waterfall/lazy-three-pack.js